import { ReactNode } from 'react';
import View from '../view';
import { Colors } from '../../../constants/theme';
import { FelaExtend } from '../../../types/fela';

type IconBadgeProps = {
  children: ReactNode;
  extend?: FelaExtend;
};

export const IconBadge = ({ children, extend }: IconBadgeProps) => (
  <View extend={[styles.badge, extend]}>{children}</View>
);

const styles = {
  badge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '36px',
    height: '36px',
    borderRadius: '18px',
    backgroundColor: Colors.light.lightGreen,
    flexShrink: 0,
  },
};
